module.exports = __webpack_public_path__ + "static/media/world-everest.bb59fe37.mp4";